export default {
  // Common
  "appName": "Qonso",
  "loading": "Chargement...",
  "error": "Une erreur est survenue",
  "success": "Succès",
  "save": "Enregistrer",
  "cancel": "Annuler", 
  "confirm": "Confirmer",
  "back": "Retour",
  "backToHome": "Retour à l'accueil",
  "backToLogin": "Retour à la connexion",
  "backToForgotPassword": "Retour au mot de passe oublié",
  "next": "Suivant",
  "submit": "Envoyer",
  "delete": "Supprimer",
  "edit": "Modifier",
  "view": "Voir",
  "close": "Fermer",
  "and": "et",
  "pleaseWait": "Veuillez patienter...",
  "verifyingLink": "Vérification de votre lien",
  
  // Auth
  "login": "Connexion",
  "register": "Inscription",
  "forgotPassword": "Mot de passe oublié",
  "resetPassword": "Réinitialiser le mot de passe",
  "email": "Email",
  "password": "Mot de passe",
  "confirmPassword": "Confirmer le mot de passe",
  "fullName": "Nom complet",
  "age": "Âge",
  "country": "Pays",
  "signIn": "Se connecter",
  "signUp": "S'inscrire",
  "signOut": "Se déconnecter",
  "createAccount": "Créer un compte",
  "creatingAccount": "Création du compte...",
  "signingIn": "Connexion en cours...",
  "signInToTrack": "Connectez-vous pour suivre votre hydratation",
  "joinQonsoToday": "Rejoignez Qonso aujourd'hui et commencez votre parcours d'hydratation !",
  "alreadyHaveAccount": "Vous avez déjà un compte ?",
  "dontHaveAccount": "Vous n'avez pas de compte ?",
  "rememberPassword": "Vous vous souvenez de votre mot de passe ?",
  "forgotPasswordQuestion": "Mot de passe oublié ?",
  "resetPasswordInstructions": "Nous vous enverrons un lien par email pour réinitialiser votre mot de passe",
  "sendResetLink": "Envoyer le lien",
  "sending": "Envoi en cours...",
  "passwordResetSent": "Un lien de réinitialisation a été envoyé à votre adresse email. Veuillez vérifier votre boîte de réception et suivre les instructions.",
  "passwordUpdated": "Mot de passe mis à jour avec succès",
  "passwordsDoNotMatch": "Les mots de passe ne correspondent pas",
  "passwordMinLength": "Le mot de passe doit contenir au moins 6 caractères",
  "emailRequired": "L'email est requis",
  "passwordRequired": "Le mot de passe est requis",
  "fullNameRequired": "Le nom complet est requis",
  "ageRequired": "L'âge est requis",
  "countryRequired": "Le pays est requis",
  "acceptTerms": "J'accepte les",
  "termsRequired": "Vous devez accepter les conditions pour continuer",
  "emailConfirmationRequired": "Veuillez vérifier votre email pour confirmer votre compte",
  "emailConfirmationSent": "Un email de confirmation a été envoyé à votre adresse. Veuillez vérifier votre boîte de réception et suivre les instructions pour compléter votre inscription.",
  "emailConfirmationSuccess": "Votre email a été confirmé avec succès !",
  "emailConfirmationFailed": "La confirmation de l'email a échoué",
  "emailConfirmed": "Email Confirmé",
  "emailVerifiedRedirect": "Votre email a été vérifié. Vous allez être redirigé vers le tableau de bord.",
  "confirmingEmail": "Confirmation de votre email",
  "pleaseWaitVerifying": "Veuillez patienter pendant que nous vérifions votre email...",
  "invalidConfirmationLink": "Lien de confirmation invalide",
  "failedToConfirmEmail": "Échec de la confirmation de l'email",
  "goToDashboard": "Aller au tableau de bord",
  "selectCountry": "Sélectionnez un pays",
  "selectCountries": "Sélectionnez les pays",
  "leaveEmptyForAllCountries": "Laissez vide pour rendre disponible dans tous les pays",
  "targetCountries": "Pays cibles",
  "allCountries": "Tous les pays",
  "pleaseAllFields": "Veuillez remplir tous les champs",
  "loginFailed": "Email ou mot de passe incorrect. Veuillez réessayer.",
  "registrationFailed": "L'inscription a échoué. Veuillez réessayer.",
  "emailAlreadyRegistered": "Cet email est déjà enregistré",
  "invalidEmail": "Veuillez entrer une adresse email valide",
  "invalidAge": "Veuillez entrer un âge valide",
  "invalidPassword": "Format de mot de passe invalide",
  "currentPassword": "Mot de passe actuel",
  "newPassword": "Nouveau mot de passe",
  "confirmNewPassword": "Confirmer le nouveau mot de passe",
  "updating": "Mise à jour...",
  "emailCannotBeChanged": "L'email ne peut pas être modifié",
  "tooManyAttempts": "Trop de tentatives. Veuillez réessayer dans quelques minutes.",
  "sessionExpired": "Votre session a expiré. Veuillez vous reconnecter.",
  "networkError": "Erreur réseau. Veuillez vérifier votre connexion et réessayer.",
  "unknownError": "Une erreur inattendue s'est produite. Veuillez réessayer.",
  "checkYourEmail": "Vérifiez votre email",
  "didntReceiveEmail": "Vous n'avez pas reçu l'email ?",
  "resendEmail": "Renvoyer l'email",
  "emailConfirmedInstructions": "Votre email a été confirmé avec succès. Vous pouvez maintenant vous connecter à votre compte.",
  "proceedToLogin": "Continuer vers la connexion",
  "passwordResetInstructions": "Nous vous enverrons un lien par email pour réinitialiser votre mot de passe.",
  "resetLinkSent": "Un nouveau lien de réinitialisation a été envoyé",
  "resetLinkFailed": "Échec de l'envoi du lien de réinitialisation",
  "emailVerificationInstructions": "Vous recevrez un lien par e-mail pour confirmer votre inscription.",
  "setNewPassword": "Définir un nouveau mot de passe",
  "createNewPassword": "Créez un nouveau mot de passe pour votre compte",
  "passwordResetComplete": "Votre mot de passe a été réinitialisé. Vous pouvez maintenant utiliser votre nouveau mot de passe pour accéder à votre compte.",
  "passwordUpdateFailed": "Échec de la mise à jour du mot de passe. Veuillez réessayer.",
  "invalidResetLink": "Lien de réinitialisation invalide ou expiré",
  "errorResendingEmail": "Erreur lors du renvoi de l'email de vérification. Veuillez réessayer plus tard.",

  // Admin
  "adminLogin": "Connexion Administrateur",
  "adminLoginDescription": "Connectez-vous pour accéder au tableau de bord administrateur",
  
  // Home
  "mainTitle": "Hydratez-vous, Cumulez, Gagnez ! 💧",
  "mainTitleHighlight": "Avec Qonso, gagnez des récompenses en buvant de l'eau",
  "homeDescription": "Qonso vous aide à vous hydrater tout en vous récompensant pour vos bonnes habitudes. Buvez de l'eau, gagnez des points et échangez-les contre des cadeaux.",
  "getStarted": "Commencer",
  "features": "Fonctionnalités",
  "whyUseQonso": "Pourquoi utiliser Qonso ?",
  "featuresDescription": "Découvrez comment Qonso vous aide à maintenir de bonnes habitudes d'hydratation tout en rendant l'expérience amusante et gratifiante.",
  "trackHydration": "Suivi d'hydratation",
  "trackHydrationDescription": "Enregistrez votre consommation d'eau quotidienne et suivez vos progrès avec notre système de suivi facile à utiliser.",
  "dailyGoals": "Objectifs quotidiens",
  "dailyGoalsDescription": "Qonso vous aide à atteindre un objectif quotidien de 2,5 L d'eau.",
  "participateSurveys": "Participez aux sondages",
  "participateSurveysDescription": "Gagnez plus de points en participant à nos différents sondages.",
  "redeemRewards": "Échangez vos récompenses",
  "redeemRewardsDescription": "Convertissez vos points gagnés en récompenses et offres spéciales.",
  
  // Benefits section
  "benefitsOfHydration": "Avantages d'une bonne hydratation",
  "benefitsDescription": "Une bonne hydratation est essentielle pour votre santé et votre bien-être. Voici pourquoi vous devriez suivre votre consommation d'eau avec Qonso.",
  "improvedEnergyLevels": "Amélioration du niveau d'énergie",
  "improvedEnergyDescription": "Rester hydraté aide à maintenir votre niveau d'énergie tout au long de la journée, réduisant la fatigue et améliorant la concentration.",
  "betterPhysicalPerformance": "Meilleure performance physique",
  "betterPhysicalDescription": "Une bonne hydratation améliore les performances physiques pendant l'exercice et les activités quotidiennes.",
  "enhancedCognition": "Fonction cognitive améliorée",
  "enhancedCognitionDescription": "L'eau aide votre cerveau à fonctionner de manière optimale, améliorant la concentration et la mémoire.",
  "healthierSkin": "Peau plus saine",
  "healthierSkinDescription": "Rester hydraté aide à maintenir l'élasticité de la peau et favorise un teint plus sain et plus radieux.",
  "improvedDigestion": "Meilleure digestion",
  "improvedDigestionDescription": "L'eau est essentielle pour une bonne digestion et aide à prévenir la constipation.",
  "joinCommunity": "Rejoignez notre communauté",
  "joinCommunityDescription": "Connectez-vous avec des milliers d'utilisateurs qui améliorent leurs habitudes d'hydratation avec Qonso.",
  
  // Testimonials
  "userTestimonials": "Ce que disent nos utilisateurs",
  "testimonialsDescription": "Rejoignez des milliers d'utilisateurs satisfaits qui ont amélioré leurs habitudes d'hydratation avec Qonso.",
  "testimonial1": "Qonso a complètement changé ma façon de suivre ma consommation d'eau. Le système de récompenses me motive !",
  "testimonialRole1": "Passionnée de fitness",
  "testimonial2": "Je n'avais jamais réalisé à quel point je buvais peu d'eau jusqu'à ce que je commence à utiliser Qonso. Maintenant, je suis correctement hydraté chaque jour.",
  "testimonialRole2": "Employé de bureau",
  "testimonial3": "Les sondages et les récompenses rendent l'hydratation amusante. J'ai déjà échangé plusieurs récompenses !",
  "testimonialRole3": "Étudiante",
  
  // CTA
  "ctaHeading": "Prêt à commencer votre parcours d'hydratation ?",
  "ctaDescription": "Rejoignez Qonso aujourd'hui et transformez vos habitudes d'hydratation tout en gagnant des récompenses passionnantes.",
  
  // Dashboard
  "welcomeBack": "Bonjour",
  "hydrationTracking": "Validez votre consommation d'eau pour gagner des points",
  "dailyGoal": "Objectif quotidien",
  "streak": "Série",
  "points": "Points",
  "daysInARow": "Jours consécutifs",
  "totalEarned": "Total des points gagnés",
  "validateConsumption": "💧Valider sa consommation d'eau",
  "dailyLimitReached": "Limite quotidienne atteinte",
  "limitReached": "Limite quotidienne atteinte !",
  "comeBackTomorrow": "Bien joué ! Tu as validé ta consommation d'aujourd'hui. On se retrouve demain ? 😉",
  "waterType": "Type d'eau",
  "plainWater": "Eau plate",
  "plainWaterDesc": "Eau ordinaire",
  "mineralWater": "Eau minérale",
  "mineralWaterDesc": "Eau minérale naturelle",
  "sparklingWater": "Eau gazeuse",
  "sparklingWaterDesc": "Eau avec bulles",
  "flavoredWater": "Eau aromatisée",
  "flavoredWaterDesc": "Eau avec arômes naturels",
  "uploadPhoto": "Veuillez prendre une photo de votre verre d'eau ou bouteille d'eau",
  "photoSelected": "Photo sélectionnée",
  "photoRequired": "Veuillez prendre une photo de votre eau ou bouteille d'eau",
  "fixedAmount": "Volume d'eau", 
  "dailyProgress": "Progression",
  "consumptionValidated": "Consommation validée",
  "validate": "Valider",
  "validating": "Validation en cours",
  "totalWaterConsumed": "Volume d’eau totale consommée",
  "lifetimeConsumption": "Consommation totale",
  "ofDailyGoals": "des objectifs quotidiens",
  "showWeeklyStats": "Afficher les statistiques hebdomadaires",
  "hideWeeklyStats": "Masquer les statistiques hebdomadaires",
  "weeklyProgress": "Progression hebdomadaire",
  "lastWeek": "Semaine dernière",
  "today": "Aujourd'hui",
  "sunday": "Dim",
  "monday": "Lun",
  "tuesday": "Mar",
  "wednesday": "Mer",
  "thursday": "Jeu",
  "friday": "Ven",
  "saturday": "Sam",
  "insights": "Aperçus",
  "lifetimeAchievement": "Vous avez consommé un total de",
  "ofWater": "d'eau depuis le début",
  "startTrackingToday": "Commencez à suivre votre consommation d'eau dès aujourd'hui !",
  "keepUpStreak": "Continuez votre série de {{streak}} jours !",
  "startStreak": "Commencez votre série aujourd'hui !",
   "streak": "Série",
  "days": "j",
  "points": "Points",
  "time": "Heure",
  "weeklyProgress": "7 Jours",
  "total": "Total",
  "goals": "Objectifs",
  
  // Rewards
  "rewards": "Récompenses",
  "rewardsCatalog": "Catalogue des récompenses",
  "rewardHistory": "Historique des récompenses",
  "rechargeCard": "Carte de recharge",
  "giftCard": "Carte cadeau",
  "request": "Demander",
  "requestReward": "Demander la récompense",
  "notEnoughPoints": "Points insuffisants",
  "rewardRequested": "Récompense demandée avec succès",
  "errorRequestingReward": "Erreur lors de la demande de récompense",
  "reward": "Récompense",
  "status": "Statut",
  "pending": "En attente",
  "approved": "Approuvé",
  "rejected": "Rejeté",
  "requestDate": "Date de la demande",
  "noRewardRequests": "Aucune demande de récompense",
  "yourPoints": "Vos points",
  "noRewards": "Pas de récompense disponible pour le moment",
  "pendingRequest": "Demande en cours",
  "alreadyRequestedReward": "Vous avez déjà une demande en cours pour cette récompense",
  "pleaseLogin": "Veuillez vous connecter pour demander des récompenses",

  // Partner Offers
  "partnerOffers": "Offres Partenaires",
  "noPartnerOffers": "Aucune offre partenaire disponible",
  "claimOffer": "Voir",
  "requesting": "Demande en cours...",
  "errorFetchingPartnerOffers": "Erreur lors de la récupération des offres partenaires",
  "currentImage": "Image actuelle",
  
  // Surveys
  "surveys": "Sondages",
  "availableSurveys": "Sondages disponibles",
  "startSurvey": "Commencer le sondage",
  "noSurveysAvailable": "Aucun sondage disponible",
  "surveyCompleted": "Sondage terminé ! Vous avez gagné {{points}} points",
  "completeSurvey": "Terminer le sondage",
  "nextQuestion": "Question suivante",
  "question": "Question",
  "pointsWorth": "Valeur",
  "completedSurveys": "Sondages complétés",
  "noCompletedSurveys": "Aucun sondage complété",
  "completedDate": "Date de complétion",
  "yes": "Oui",
  "no": "Non",
  
  // Settings
  "settings": "Paramètres",
  "profileSettings": "Paramètres du profil",
  "changePassword": "Changer le mot de passe",
  "updateProfile": "Mettre à jour le profil",
  "updatePassword": "Mettre à jour le mot de passe",
  "profileUpdated": "Profil mis à jour avec succès",
  "passwordUpdated": "Mot de passe mis à jour avec succès",
  "deleteAccount": "Supprimer le compte",
  "deleteMyAccount": "Supprimer mon compte",
  "deleteAccountDescription": "Si vous souhaitez supprimer votre compte et toutes les données associées, veuillez cliquer sur le bouton ci-dessous. Cette action vous redirigera vers un formulaire où vous pourrez soumettre votre demande de suppression.",
  
  // Navigation
  "dashboard": "Tableau de bord",
  "notifications": "Notifications",
  "noNotifications": "Aucune notification",
  "markAllAsRead": "Tout marquer comme lu",
  "markAsRead": "Marquer comme lu",
  
  // Footer
  "privacyPolicy": "Politique de confidentialité",
  "termsOfService": "Conditions d'utilisation",
  "legalNotice": "Mentions légales",
  "contact": "Contact",
  "contactEmail": "contact@qonso.app",
  "allRightsReserved": "© 2025 Qonso. Tous droits réservés."
};